import {CountUp} from "countup.js";

export function blockStats() {
    document.querySelectorAll('.stats-block').forEach((container) => {
        container.querySelectorAll('.number').forEach((number) => {
            let end_number = number.dataset.number,
                start_number = (end_number > 100) ?  (end_number * 0.8) : 0,
                suffix = number.dataset.suffix;

            let numb = new CountUp(number, end_number, {
                startVal : start_number,
                suffix: suffix,
                duration: 0.75,
                enableScrollSpy: true,
                scrollSpyOnce: true,
                useEasing: false
            })
            numb.start()
        })
    })
}